import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'throttle-debounce'
import { FaExclamationTriangle } from 'react-icons/fa'

import { Textarea } from '../../Textarea'

const OrderNotes = ({ loading, notes, updateOrder }) => {
  const [value, setValue] = useState(notes || '')

  const handleSaveNotes = useCallback(debounce(850, updateOrder), [])

  return (
    <div className="inline-block">
      <div className="flex justify-end flex-wrap mt-4">
        <Textarea
          disabled={loading}
          label="Notes"
          onChange={e => {
            setValue(e.target.value)
            handleSaveNotes({ notes: e.target.value }, true)
          }}
          value={value}
        />
        <div className="w-full text-center">
          <p className="mt-4 rounded text-gray-400">
            <span className="mr-2 inline-block -mb-1 text-xl">
              <FaExclamationTriangle />
            </span>{' '}
            For internal use - not shown on purchase order
          </p>
        </div>
      </div>
    </div>
  )
}

OrderNotes.propTypes = {
  loading: PropTypes.bool,
  notes: PropTypes.string,
  updateOrder: PropTypes.func.isRequired,
}

OrderNotes.defaultProps = {
  loading: false,
  notes: '',
}

export { OrderNotes }
